module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('router-link', {
    staticClass: "view-controls__link",
    class: (_vm.scene < _vm.current) ? 'view-controls__link--active' : '',
    attrs: {
      "to": _vm.to,
      "active-class": "view-controls__link--active"
    }
  }, [_h('span', {
    staticClass: "view-controls__link-label"
  }, [_vm._t("default")]), " ", _h('div', {
    staticClass: "view-controls__link-icon",
    domProps: {
      "innerHTML": _vm._s(_vm.icon)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00338d40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewLink.vue
// module id = 212
// module chunks = 2